/* ============================================================
   YANIKO GOLD — Collection (catalog) behaviour
   Filter drawer, floating bar, sort, AJAX "load more", description
   toggle. Shopify does the actual filtering/sorting server-side via
   the filter <form> and sort_by; this only handles UI + progressive
   "load more". Scoped to [data-yg-collection].
   ============================================================ */
(function () {
  "use strict";

  function init(root) {
    if (!root || root.__ygColInit) return;
    root.__ygColInit = true;
    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    /* ---------- Reveal the initial product cards (they start hidden via CSS) ---------- */
    function revealCards(scope) {
      var cards = (scope || root).querySelectorAll(".cl-grid .p-card:not(.is-in)");
      if (!cards.length) return;
      if (reduceMotion || !("IntersectionObserver" in window)) {
        cards.forEach(function (c) { c.classList.add("is-in"); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
      }, { threshold: 0.08, rootMargin: "0px 0px -40px 0px" });
      cards.forEach(function (c) { io.observe(c); });
      // safety net: never leave cards invisible
      setTimeout(function () { cards.forEach(function (c) { c.classList.add("is-in"); }); }, 1200);
    }
    revealCards(root);

    /* ---------- Filter drawer ---------- */
    var drawer = root.querySelector(".filters");
    var scrim = root.querySelector(".cl-scrim");
    var drawerOpener = null;
    function openDrawer(opener) {
      if (!drawer) return;
      drawerOpener = opener || null;
      drawer.classList.add("is-on"); drawer.setAttribute("aria-hidden", "false");
      if (scrim) scrim.classList.add("is-on");
      document.documentElement.style.overflow = "hidden";
      document.documentElement.classList.add("yg-filters-open");
      document.body.style.overflow = "hidden";
      drawer.focus({ preventScroll: true });
    }
    function closeDrawer() {
      if (!drawer || !drawer.classList.contains("is-on")) return;
      drawer.classList.remove("is-on"); drawer.setAttribute("aria-hidden", "true");
      if (scrim) scrim.classList.remove("is-on");
      document.documentElement.style.overflow = "";
      document.documentElement.classList.remove("yg-filters-open");
      document.body.style.overflow = "";
      if (drawerOpener) { drawerOpener.focus({ preventScroll: true }); drawerOpener = null; }
    }
    root.addEventListener("click", function (e) {
      var opener = e.target.closest("[data-filter-open]");
      if (opener) { e.preventDefault(); openDrawer(opener); }
      else if (e.target.closest("[data-filter-close]")) { closeDrawer(); }
    });
    /* keep the URL clean: empty price boxes are not sent */
    var filterForm = root.querySelector("[data-filter-form]");
    if (filterForm) filterForm.addEventListener("formdata", function (e) {
      filterForm.querySelectorAll('input[type="number"]').forEach(function (i) {
        if (i.value === "") e.formData.delete(i.name);
      });
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });

    /* ---------- Filter tree: "Покажи още" + subtype reveal under the chosen jewellery type ---------- */
    if (drawer) {
      drawer.addEventListener("click", function (e) {
        var more = e.target.closest("[data-more]");
        if (!more) return;
        var box = more.closest(".filters__opts");
        var on = box.classList.toggle("is-expanded");
        more.setAttribute("aria-expanded", on ? "true" : "false");
        more.textContent = on ? "Покажи по-малко" : (more.getAttribute("data-label") || "Покажи още");
      });
      /* a subtype list belongs to its type: visible while the type is ticked (or while one of its boxes is ticked) */
      var syncTree = function () {
        drawer.querySelectorAll("[data-sub-for]").forEach(function (sub) {
          var t = sub.getAttribute("data-sub-for"), on = false;
          drawer.querySelectorAll("[data-type-toggle]").forEach(function (cb) {
            if (cb.getAttribute("data-type") === t && cb.checked) on = true;
          });
          sub.hidden = !(on || sub.querySelector("input:checked"));
        });
      };
      drawer.addEventListener("change", function (e) {
        var cb = e.target.closest("[data-type-toggle]");
        if (!cb) return;
        if (!cb.checked) {
          /* un-ticking a type drops what was ticked under it, so nothing hidden is sent */
          drawer.querySelectorAll("[data-sub-for]").forEach(function (sub) {
            if (sub.getAttribute("data-sub-for") === cb.getAttribute("data-type")) {
              sub.querySelectorAll("input:checked").forEach(function (i) { i.checked = false; });
            }
          });
        }
        syncTree();
      });
      window.addEventListener("pageshow", syncTree);
      syncTree();
    }

    /* ---------- Floating filter/sort bar (reveal after scrolling past the toolbar) ---------- */
    var floatbar = root.querySelector(".cl-floatbar");
    var toolbar = root.querySelector(".toolbar");
    if (floatbar && toolbar) {
      var onScroll = function () {
        var r = toolbar.getBoundingClientRect();
        floatbar.classList.toggle("is-on", r.bottom < 0);
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    }

    /* ---------- Sort: navigate with sort_by, preserving filters ---------- */
    root.querySelectorAll("[data-sort]").forEach(function (sel) {
      sel.addEventListener("change", function () {
        var url = new URL(window.location.href);
        url.searchParams.set("sort_by", sel.value);
        url.searchParams.delete("page");
        window.location.href = url.toString();
      });
    });

    /* ---------- Description toggle ---------- */
    var descToggle = root.querySelector("[data-desc-toggle]");
    var desc = root.querySelector("[data-desc]");
    if (descToggle && desc) {
      descToggle.addEventListener("click", function () {
        var open = desc.classList.toggle("is-open");
        descToggle.textContent = open ? "Скрий" : "Прочети още";
      });
    }

    /* ---------- AJAX "load more" ---------- */
    /* Само бутонът „Зареди още“ под мрежата. Чекмеджето с филтрите има свои бутони „Покажи още“ със същия
       атрибут и стоят по-рано в страницата — без [data-loadwrap] тук се хващаше чекмеджето, а истинският
       бутон оставаше без обработчик и само отваряше следващата страница (от 04.10.2026). */
    var moreBtn = root.querySelector("[data-loadwrap] [data-more]");
    var grid = root.querySelector("[data-grid]");
    var moreBar = root.querySelector("[data-more-bar]");
    var moreInfo = root.querySelector("[data-more-info]");
    var loadedMore = false;
    if (moreBtn && grid) {
      moreBtn.addEventListener("click", function (e) {
        var next = moreBtn.getAttribute("href") || moreBtn.getAttribute("data-next");
        if (!next) return;
        e.preventDefault();
        moreBtn.classList.add("is-loading");
        moreBtn.textContent = "Зареждане…";
        fetch(next, { headers: { "X-Requested-With": "XMLHttpRequest" } })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, "text/html");
            var newGrid = doc.querySelector("[data-grid]");
            if (newGrid) {
              Array.prototype.slice.call(newGrid.children).forEach(function (card) {
                if (card.classList && card.classList.contains("p-card")) {
                  grid.appendChild(card);
                  if (!reduceMotion) { requestAnimationFrame(function () { card.classList.add("is-in"); }); }
                  else { card.classList.add("is-in"); }
                }
              });
            }
            if (window.__ygApplyWish) window.__ygApplyWish();
            loadedMore = true;
            var newMore = doc.querySelector("[data-loadwrap] [data-more]");
            var newInfo = doc.querySelector("[data-more-info]");
            var newBar = doc.querySelector("[data-more-bar]");
            if (newInfo && moreInfo) moreInfo.textContent = newInfo.textContent;
            if (newBar && moreBar) moreBar.style.width = newBar.style.width;
            // keep the crawlable page links in step with what is now on screen
            var pagenav = root.querySelector("[data-pagenav]");
            var newPagenav = doc.querySelector("[data-pagenav]");
            if (pagenav && newPagenav) pagenav.innerHTML = newPagenav.innerHTML;
            if (newMore && newMore.getAttribute("href")) {
              moreBtn.setAttribute("href", newMore.getAttribute("href"));
              moreBtn.classList.remove("is-loading");
              moreBtn.textContent = "Зареди още";
            } else {
              var wrap = root.querySelector("[data-loadwrap]");
              moreBtn.remove();
              if (moreBar && moreBar.parentNode) moreBar.parentNode.style.display = "none";
            }
          })
          .catch(function () {
            moreBtn.classList.remove("is-loading");
            moreBtn.textContent = "Зареди още";
            window.location.href = next;
          });
      });
    }

    /* ---------- Restore loaded products + scroll position on BACK navigation ----------
       Keeps the customer where they were after viewing a product, instead of
       sending them back to the top of the catalogue.

       Three things have to be handled, or the customer lands at the top:
         1. bfcache restore  — the browser hands back the whole live page and
            never re-runs this script, so the work must happen in `pageshow`.
         2. re-parsed back nav — the page is built from scratch; the grid has to
            be rebuilt from sessionStorage first, then scrolled.
         3. late layout shifts — lazy images and fonts settle after the first
            frame, so the target position is re-applied for a short while.
       State is kept under ONE sessionStorage key so it can never accumulate
       past the storage quota. ------------------------------------------------ */
    if (grid) {
      if ("scrollRestoration" in history) {
        try { history.scrollRestoration = "manual"; } catch (e) {}
      }

      var STORE_KEY = "ygcol:states";
      var MAX_HTML = 900000; // ~0.9 MB — well inside the ~5 MB session quota
      var MAX_SLOTS = 3;     // remember the last few catalogues, not just one
      var anchorHref = "";   // product link the customer clicked through

      var pageKey = function () {
        var u = new URL(window.location.href);
        u.searchParams.delete("page");
        return u.pathname + u.search;
      };

      var currentY = function () {
        return window.pageYOffset || document.documentElement.scrollTop || 0;
      };

      var readSlots = function () {
        var raw = null;
        try { raw = sessionStorage.getItem(STORE_KEY); } catch (e) {}
        if (!raw) return [];
        try {
          var arr = JSON.parse(raw);
          return Object.prototype.toString.call(arr) === "[object Array]" ? arr : [];
        } catch (e) { return []; }
      };

      /* Keep the last few catalogues, most recent first, so going back through
         collection B to collection A still restores A. Writing is quota-safe:
         if the payload is refused, shed the older grids, then the older slots,
         rather than losing the state the customer is about to come back to. */
      var saveState = function () {
        var html = loadedMore ? grid.innerHTML : "";
        if (html.length > MAX_HTML) html = ""; // fall back to scroll-only restore
        var pagenavEl = root.querySelector("[data-pagenav]");
        var key = pageKey();
        var data = {
          key: key,
          html: html,
          pagenav: pagenavEl ? pagenavEl.innerHTML : "",
          next: (moreBtn && moreBtn.parentNode) ? (moreBtn.getAttribute("href") || "") : "done",
          info: moreInfo ? moreInfo.textContent : "",
          barW: moreBar ? moreBar.style.width : "",
          anchor: anchorHref,
          y: currentY()
        };

        var slots = readSlots().filter(function (s) { return s && s.key !== key; });
        slots.unshift(data);
        slots = slots.slice(0, MAX_SLOTS);

        var write = function (list) {
          try { sessionStorage.setItem(STORE_KEY, JSON.stringify(list)); return true; }
          catch (e) { return false; }
        };
        if (write(slots)) return;
        for (var i = slots.length - 1; i > 0; i--) {   // drop older grids first
          slots[i].html = "";
          if (write(slots)) return;
        }
        while (slots.length > 1) {                     // then older slots
          slots.pop();
          if (write(slots)) return;
        }
        slots[0].html = "";                            // last resort: scroll only
        write(slots);
      };

      var readState = function () {
        var key = pageKey();
        var slots = readSlots();
        for (var i = 0; i < slots.length; i++) {
          if (slots[i] && slots[i].key === key) return slots[i];
        }
        return null;
      };

      /* Re-apply the target position across ~900ms so lazy images, web fonts and
         late reflows cannot drag the customer away from where they were. */
      var pinScroll = function (state) {
        var cancelled = false;
        var stop = function () { cancelled = true; };
        ["wheel", "touchstart", "keydown"].forEach(function (ev) {
          window.addEventListener(ev, stop, { passive: true, once: true });
        });

        /* Match on the parsed pathname, not the raw attribute — Shopify may hang
           ?variant= / ?_pos= on a card link, and a prefix match would grab the
           wrong product (/products/pendant vs /products/pendant-gold). */
        var findAnchorCard = function (path) {
          var links = grid.querySelectorAll("a[href]");
          for (var i = 0; i < links.length; i++) {
            var href = "";
            try { href = new URL(links[i].href, location.origin).pathname; } catch (e) { href = links[i].getAttribute("href") || ""; }
            if (href === path) return links[i].closest(".p-card");
          }
          return null;
        };

        var anchorCard = state.anchor ? findAnchorCard(state.anchor) : null;
        var target = function () {
          if (anchorCard) {
            var r = anchorCard.getBoundingClientRect();
            // park the card a little below the top edge, so it reads as "where I was"
            return Math.max(0, r.top + currentY() - Math.round(window.innerHeight * 0.28));
          }
          return typeof state.y === "number" ? state.y : 0;
        };

        var deadline = Date.now() + 900;
        var tick = function () {
          if (cancelled) return;
          var y = target();
          if (Math.abs(currentY() - y) > 2) window.scrollTo(0, y);
          if (Date.now() < deadline) requestAnimationFrame(tick);
          else window.removeEventListener("wheel", stop);
        };
        requestAnimationFrame(tick);
      };

      var rebuildGrid = function (s) {
        if (!s.html) return;
        grid.innerHTML = s.html;
        loadedMore = true;
        Array.prototype.forEach.call(grid.querySelectorAll(".p-card"), function (c) {
          c.classList.add("is-in");
        });
        if (moreBtn) {
          if (s.next && s.next !== "done") moreBtn.setAttribute("href", s.next);
          else {
            moreBtn.remove();
            if (moreBar && moreBar.parentNode) moreBar.parentNode.style.display = "none";
          }
        }
        if (moreInfo && s.info) moreInfo.textContent = s.info;
        if (moreBar && s.barW) moreBar.style.width = s.barW;
        var pn = root.querySelector("[data-pagenav]");
        if (pn && s.pagenav) pn.innerHTML = s.pagenav;
        if (window.__ygApplyWish) window.__ygApplyWish();
      };

      /* Remember which product was opened — that card is the restore anchor. */
      grid.addEventListener("click", function (e) {
        var a = e.target.closest("a[href]");
        if (!a) return;
        try { anchorHref = new URL(a.href, location.origin).pathname; } catch (err) { anchorHref = a.getAttribute("href") || ""; }
        saveState();
      }, true);
      window.addEventListener("pagehide", saveState);

      var navType = "";
      try {
        var ne = performance.getEntriesByType && performance.getEntriesByType("navigation");
        if (ne && ne[0]) navType = ne[0].type;
        else if (performance.navigation && performance.navigation.type === 2) navType = "back_forward";
      } catch (e) {}

      /* Path 2+3: the document was parsed fresh on a back/forward navigation. */
      if (navType === "back_forward") {
        var s = readState();
        if (s) { rebuildGrid(s); pinScroll(s); }
      }

      /* Path 1: bfcache — the live page comes back and this script does not
         re-run, so `pageshow` is the only hook we get. */
      window.addEventListener("pageshow", function (e) {
        if (!e.persisted) return;
        var s2 = readState();
        if (s2) pinScroll(s2); // DOM is already intact; only the position is lost
      });
    }
  }

  function boot() {
    document.querySelectorAll("[data-yg-collection]").forEach(init);
  }
  if (document.readyState !== "loading") boot();
  else document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", function (e) {
    if (e.target.querySelectorAll) e.target.querySelectorAll("[data-yg-collection]").forEach(init);
  });
})();
